module.exports = __webpack_public_path__ + "img/no-results.3da9e28e.png";